export default __webpack_public_path__ + "static/media/erd.336efc4c.png";